import type { CardAccessClaimResult } from '@lub0v/santa-utils';

// Keep the one-time response through setup/reloads until explicitly acknowledged.
const key = (box: string, card: string) => `participant_access:${box}:${card}`;
const pending = new Map<string, CardAccessClaimResult>();
export function storeParticipantAccess(box: string, card: string, data: CardAccessClaimResult) {
  if (!data.recoveryCodes?.length) return;
  pending.set(key(box, card), data);
  try { sessionStorage.setItem(key(box, card), JSON.stringify(data)); } catch { /* Memory fallback. */ }
}
export function peekParticipantAccess(box: string, card: string): CardAccessClaimResult | undefined {
  const cached = pending.get(key(box, card));
  if (cached) return cached;
  try {
    const data = JSON.parse(sessionStorage.getItem(key(box, card)) || 'null');
    if (typeof data?.cardUrl === 'string' && typeof data?.redirect === 'string' &&
      Array.isArray(data.recoveryCodes) && data.recoveryCodes.length &&
      data.recoveryCodes.every((code: unknown) => typeof code === 'string')) return data;
  } catch { /* Missing or unavailable storage. */ }
  return undefined;
}
export function clearParticipantAccess(box: string, card: string) {
  pending.delete(key(box, card));
  try { sessionStorage.removeItem(key(box, card)); } catch { /* Memory fallback. */ }
}
